import { FaLock, FaShieldAlt, FaBiohazard } from 'react-icons/fa';

const pricing = [
  {
    id: 1,
    icon: <FaLock />, // Lock icon
    title: 'Standard Plan',
    price: 49,
    features: [
      'Emergency Lockout Assistance',
      'Key Duplication Services',
      'Lock Repair and Installation',
      'Security Assessment',
      'Priority Service',
    ],
  },
  {
    id: 2,
    icon: <FaShieldAlt />, // Shield icon
    title: 'Premium Plan',
    price: 79,
    features: [
      '24/7 Emergency Response',
      'Advanced Security Solutions',
      'High-Security Lock Installation',
      'Burglary Damage Repair',
      'VIP Customer Support',
    ],
  },
  {
    id: 3,
    icon: <FaBiohazard />, // Shield Virus icon alternative
    title: 'Ultimate Plan',
    price: 99,
    features: [
      'Comprehensive Security Package',
      'Biometric Lock Installation',
      '24/7 Monitoring Service',
      'Emergency Response Team',
      'Custom Security Solutions',
    ],
  },
];

export default pricing;